(function() {

    'use strict';

    angular.module('app').config(manifestsUrlConfig);

    manifestsUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function manifestsUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/manifests/view/:manifestId', {
            templateUrl: '/templates/pages/manifests/view.html',
            controller: 'ManifestsViewController',
            controllerAs: 'ms',
            params: {
                parent: 'manifests',
                subParent: 'scheduledPickups',
                htmlTitle: 'Manifests',
                pageTitle: 'Manifests'
            }
        })
        .when('/manifests/create', {
            templateUrl: '/templates/pages/manifests/view.html',
            controller: 'ManifestsViewController',
            controllerAs: 'ms',
            params: {
                parent: 'manifests',
                subParent: 'scheduledPickups',
                htmlTitle: 'Manifests',
                pageTitle: 'Manifests'
            }
        })
        .when('/manifests/non-manifested-by-location/:companyId', {
            templateUrl: '/templates/pages/manifests/non-manifested-by-location.html',
            controller: 'NonManifestedShipmentsByLocation',
            controllerAs: 'vm',
            params: {
                parent: 'manifests',
                subParent: 'nonManifestSearch',
                htmlTitle: 'Non-Manifested Shipments by location',
                pageTitle: 'Manifests'
            }
        })
        .when('/manifests/non-manifested-by-carrier/:carrierId', {
            templateUrl: '/templates/pages/manifests/non-manifested-by-carrier.html',
            controller: 'NonManifestedShipmentsByCarrier',
            controllerAs: 'vm',
            params: {
                parent: 'manifests',
                subParent: 'nonManifestSearch',
                htmlTitle: 'Non-Manifested Shipments by carrier',
                pageTitle: 'Manifests'
            }
        })
        .when('/ftp-direct-booking', {
            templateUrl: '/templates/pages/manifests/ftpDirectBookingHistory.html',
            controller: 'FtpDirectBookingHistoryController',
            controllerAs: 'vm',
            params: {
                parent: 'manifests',
                subParent: 'manifests',
                htmlTitle: 'FTP Direct Booking and Manifesting',
                pageTitle: 'FTP Direct Booking and Manifesting'
            }
        })
        .when('/truck-information-audit', {
            templateUrl: '/templates/pages/manifests/truckInformationAudit.html',
            controller: 'TruckInformationAuditController',
            controllerAs: 'vm',
            params: {
                parent: 'manifests',
                subParent: 'truckInformationAudit',
                htmlTitle: 'Truck/Driver Information Audit',
                pageTitle: 'Truck/Driver Information Audit'
            }
        })
        .when('/truck-information-audit/:driverId', {
            templateUrl: '/templates/pages/manifests/truckLoadInformation.html',
            controller: 'TruckLoadInformationAuditController',
            controllerAs: 'vm',
            params: {
                parent: 'manifests',
                subParent: 'truckInformationAudit',
                htmlTitle: 'Truck/Driver Information Audit',
                pageTitle: 'Truck/Driver Information Audit'
            }
        });

        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }

})();


// WEBPACK FOOTER //
// ./js/urls/manifests.js